// extracted by mini-css-extract-plugin
module.exports = {"FullLayout":"FullLayout_FullLayout__1KffV"};